module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('multiselect', {
    attrs: {
      "value": _vm.selected ? _vm.selected : _vm.formattedValue,
      "placeholder": _vm.placeholder,
      "options": _vm.formattedOptions,
      "label": "item",
      "track-by": "item",
      "multiple": _vm.multiple,
      "taggable": true,
      "showNoResults": true
    },
    on: {
      "input": _vm.updateValue,
      "tag": _vm.create
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-358e1fc4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/atoms/TagInput.vue
// module id = 647
// module chunks = 1